/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SingleProductMedia } from './single-product-media';
/**
 * 
 * @export
 * @interface ProductVariantPopulated
 */
export interface ProductVariantPopulated {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    sku: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    upc: string;
    /**
     * 
     * @type {Array<SingleProductMedia>}
     * @memberof ProductVariantPopulated
     */
    media: Array<SingleProductMedia>;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    retailPrice: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    finalPrice: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariantPopulated
     */
    isDiscounted: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    discountAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    inventoryCount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    inventoryStatus: ProductVariantPopulatedInventoryStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    totalSold: number;
    /**
     * Width in inches
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    width: number;
    /**
     * Height in inches
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    height: number;
    /**
     * Length in inches
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    length: number;
    /**
     * Weight in oz
     * @type {number}
     * @memberof ProductVariantPopulated
     */
    weight: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariantPopulated
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProductVariantPopulated
     */
    inventoryLastUpdated: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    discount: string;
    /**
     * Parent product name (e.g. \"Advil\")
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    productName: string;
    /**
     * Parent product ID
     * @type {string}
     * @memberof ProductVariantPopulated
     */
    productId: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductVariantPopulatedInventoryStatusEnum {
    INSTOCK = 'IN_STOCK',
    OUTOFSTOCK = 'OUT_OF_STOCK',
    LOWSTOCK = 'LOW_STOCK'
}

